<template>
  <div >
    <el-row>
      <el-col :span="24">
        <div class="nodelogo-wrapper">
          <img class="nodelogo" :src="offchaindata.logo_url" />
        </div>
      </el-col>
    </el-row>
    <detailitem-nav :title="$t('detail.name')" :text="offchaindata.name" texttype="1"></detailitem-nav>
    <detailitem-nav v-if="$route.params.pk !== '0353411df6bebc3c9d8a8160ed02ff432945a5930c5c5f4ae1133b379444c21c4a'"  :title="$t('detail.rank')" :num="onchaindata.node_rank" texttype="2"></detailitem-nav>
    <detailitem-nav v-if="$route.params.pk === '0353411df6bebc3c9d8a8160ed02ff432945a5930c5c5f4ae1133b379444c21c4a'"  :title="$t('detail.rank')" :num="node_rank" texttype="2"></detailitem-nav>
    <detailitem-nav :title="$t('detail.position')" :text="offchaindata.region" texttype="1"></detailitem-nav>
    <detailitem-nav :title="$t('detail.address')" :text="offchaindata.address" texttype="address"></detailitem-nav>
    <detailitem-nav v-if="offchaindata.website" :title="$t('detail.website')" :text="offchaindata.website" texttype="1"></detailitem-nav>
    <detailitem-nav v-if="offchaindata.social" :title="$t('detail.social')" :text="offchaindata.social" texttype="1"></detailitem-nav>
    <detailitem-nav :title="$t('detail.pk')" :text="offchaindata.public_key" texttype="1"></detailitem-nav>
    <detailitem-nav v-if="$route.params.pk !== '0353411df6bebc3c9d8a8160ed02ff432945a5930c5c5f4ae1133b379444c21c4a'" :title="$t('detail.stakeamount')" :num="onchaindata.init_pos" texttype="ont"></detailitem-nav>
    <detailitem-nav v-if="$route.params.pk === '0353411df6bebc3c9d8a8160ed02ff432945a5930c5c5f4ae1133b379444c21c4a'" :title="$t('detail.stakeamount')" :num="init_pos" texttype="ont"></detailitem-nav>
    <detailitem-nav v-if="$route.params.pk !== '0353411df6bebc3c9d8a8160ed02ff432945a5930c5c5f4ae1133b379444c21c4a'" :title="$t('detail.userstake')" :num="onchaindata.current_stake - onchaindata.init_pos" texttype="ont"></detailitem-nav>
    <detailitem-nav v-if="$route.params.pk === '0353411df6bebc3c9d8a8160ed02ff432945a5930c5c5f4ae1133b379444c21c4a'" :title="$t('detail.userstake')" :num="current_stake - init_pos" texttype="ont"></detailitem-nav>
    <detailitem-nav :title="$t('detail.description')" :text="offchaindata.introduction" texttype="1"></detailitem-nav>
  </div>
</template>

<script>
import DetailitemNav from "./Detailoverviewinfoitem";
export default {
  name: "progresss",
  components: {
    DetailitemNav
  },
  props: {
    onchaindata: {
      type: Object
    },
    offchaindata: {
      type: Object
    }
  },
  data() {
    return {
      node_rank:"N/A",
      init_pos:200000,
      current_stake:200000,
    }
  },
  mounted(){
    if(this.$route.params.pk === "0353411df6bebc3c9d8a8160ed02ff432945a5930c5c5f4ae1133b379444c21c4a"){
      this.onchaindata.node_rank = "N/A"
      this.onchaindata.init_pos = 200000
      this.onchaindata.current_stake = 200000
    }
  },
  beforeDestroy(){
    this.offchaindata.logo_url = ''
  }
};
</script>
<style>
.nodelogo-wrapper{
  padding:23px 0;
}
.nodelogo{
  width: 86px;
}
</style>

